import { LOCALE } from "@/constants/locale";

export enum DATE_FORMAT {
    DD_MM_YYYY = "dd.MM.yyyy",
    YYYY_MM_DD = "yyyy-MM-dd",
    MM_DD_YYYY = "MM/dd/yyyy",
    DD_MM_YYYY_slash = "dd/MM/yyyy",
}

export const DATE_FORMAT_OPTIONS = [
    { value: DATE_FORMAT.DD_MM_YYYY, label: `"day_short"."month_short"."year_long"` },
    { value: DATE_FORMAT.YYYY_MM_DD, label: `"year_long"-"month_short"-"day_short"` },
    { value: DATE_FORMAT.MM_DD_YYYY, label: `"month_short"/"day_short"/"year_long"` },
    { value: DATE_FORMAT.DD_MM_YYYY_slash, label: `"day_short"/"month_short"/"year_long"` },
];

export const DATE_FORMAT_OPTIONS_ALL_LOCALES: Record<string, typeof DATE_FORMAT_OPTIONS> = {
    [LOCALE.ENGLISH]: DATE_FORMAT_OPTIONS,
    [LOCALE.SPANISH]: DATE_FORMAT_OPTIONS,
    [LOCALE.TURKISH]: DATE_FORMAT_OPTIONS,
    [LOCALE.GERMAN]: DATE_FORMAT_OPTIONS,
    [LOCALE.ARABIC]: DATE_FORMAT_OPTIONS,
    [LOCALE.ITALIAN]: DATE_FORMAT_OPTIONS,
    [LOCALE.FRENCH]: DATE_FORMAT_OPTIONS,
};

export function getDateFormatOptions(locale: string): typeof DATE_FORMAT_OPTIONS {
    return DATE_FORMAT_OPTIONS_ALL_LOCALES[locale] ?? DATE_FORMAT_OPTIONS;
}

export enum TIME_FORMAT {
    TWENTY_FOUR_HOURS = "HH:mm",
    TWELVE_HOURS = "hh:mm a",
}

export const TIME_FORMAT_OPTIONS = [
    { value: TIME_FORMAT.TWENTY_FOUR_HOURS, label: "24_hours_format" },
    { value: TIME_FORMAT.TWELVE_HOURS, label: "am_pm_format" },
];

export const TIME_FORMAT_OPTIONS_ALL_LOCALES: Record<string, typeof TIME_FORMAT_OPTIONS> = {
    [LOCALE.ENGLISH]: TIME_FORMAT_OPTIONS,
    [LOCALE.SPANISH]: TIME_FORMAT_OPTIONS,
    [LOCALE.TURKISH]: TIME_FORMAT_OPTIONS,
    [LOCALE.GERMAN]: TIME_FORMAT_OPTIONS,
    [LOCALE.ARABIC]: TIME_FORMAT_OPTIONS,
    [LOCALE.ITALIAN]: TIME_FORMAT_OPTIONS,
    [LOCALE.FRENCH]: TIME_FORMAT_OPTIONS,
};

export function getTimeFormatOptions(locale: string): typeof TIME_FORMAT_OPTIONS {
    return TIME_FORMAT_OPTIONS_ALL_LOCALES[locale] ?? TIME_FORMAT_OPTIONS;
}
